import { Button, DatePicker, Input, List, message, Modal, Spin } from 'antd';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useConfigQuery } from '../../../../queries/useConfig';
import { api } from '../../../../config/api';

const Log = ({ onItemPress, closeModal, tratarProdutosOrcamento }) => {
    const dispatch = useDispatch();
    const [baixarImprimirPdf, setBaixarImprimirPdf] = useState(true);
    const [isModalVisibleLeitor, setIsModalVisibleLeitor] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [termo, setTermo] = useState('hoje');
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [restauranteId, setRestauranteId] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [buscaPorData, setBuscaPorData] = useState(false);
    const [showDateSelector, setShowDateSelector] = useState(false);
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [loja, setLoja] = useState('');
    const [dates, setDates] = useState(null);
    const { RangePicker } = DatePicker;
    const { data: config, error } = useConfigQuery();
    const accessToken = window.localStorage.getItem('accessToken');
    const idUser = window.localStorage.getItem('idUser');


    const [vendasNaoSalvas, setVendasNaoSalvas] = useState('');
    const [arrayVendas, setArrayVendas] = useState([]);


    useEffect(() => {
        if (accessToken && idUser) {
            const options = {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            };
            axios
                .get(`${api.techfood}/v1/restaurantes/usuario/${idUser}`, options)
                .then((restaurante) => {
                    setLoja(restaurante.data);
                });
        }
    }, [idUser, accessToken]);



    const handleSaveDates = async (datesp) => {
        setBuscaPorData(true);
        setIsLoading(true);
        const dataInicio = datesp[0].toISOString().split('T')[0];
        const dataFim = datesp[1].toISOString().split('T')[0];


        if (accessToken) {
            try {
                const options = {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`,
                    },
                };
                const response = await axios.get(
                    `${api.techspdv}/v1/pdveventos/periodotipo/${loja.id}/${dataInicio}/${dataFim}/4/${config?.tpAmb}?page=0`,
                    options
                );

                if (response.data._embedded.PDVEvento.length > 0) {
                    setVendasNaoSalvas(response.data._embedded.PDVEvento);
                    setTotalPages(response.data.page.totalPages);
                    setCurrentPage(response.data.page.number);
                } else {
                    setCurrentPage(0);
                    setVendasNaoSalvas([]);
                }
            } catch (error) {
                setVendasNaoSalvas([]);
                console.error('Erro ao carregar cupomFiscal:', error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const toggleDateSelector = () => {
        setShowDateSelector(!showDateSelector);
    };

    const toggleModalLeitor = () => {
        setIsModalVisibleLeitor(!isModalVisibleLeitor);
    };


    const buscaNotas = async termo => {
        setBuscaPorData(false);
        setTermo(termo);
        setCurrentPage(0);

        if (accessToken) {
            console.log('dentro da busca');
            try {

                const options = {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + accessToken,
                    },
                };

                const response = await axios.get(
                    `${api.techspdv}/v1/logs/loja/${loja.id}/filtro/${termo}`,
                    options,
                );

                if (response.data.length > 0) {
                    console.log(response.data);
                    const produtosTratados = response.data.reduce((acc, item) => {
                        try {
                            const logParse = JSON.parse(item.log);
                            acc.push(logParse);
                        } catch (e) {
                            // ignora os que falharem no parse
                        }
                        return acc;
                    }, []);


                    console.log(produtosTratados);
                    setArrayVendas(produtosTratados);
                } else {
                    setCurrentPage(0);
                    setArrayVendas([]);
                }
            } catch (error) {
                setArrayVendas([]);
                console.error('Erro ao carregar cupomFiscal:', error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    function formatarCpfCnpj(cpfCnpj) {
        cpfCnpj = cpfCnpj.replace(/\D/g, '');

        if (cpfCnpj.length === 11) {
            return cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else if (cpfCnpj.length === 14) {
            return cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        } else {
            return cpfCnpj;
        }
    }

    function formatarValorEmReais(valor) {
        const simboloMoeda = 'R$';
        const valorFormatado = parseFloat(valor).toFixed(2).replace('.', ',');

        const partes = valorFormatado.split(',');
        partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        return simboloMoeda + ' ' + partes.join(',');
    }


    const handleItemPress = async venda => {
        console.log('clicando');
        let resp = false;
        if (venda.cancelamento && venda.cancelamento === true) {
            console.log('cancelamento');
            setIsLoading(true);
            resp = await cancelarEvento(venda);
            console.log(resp.data);
            setIsLoading(false);
        } else {
            setIsLoading(true);
            resp = await criarEvento(venda);
            console.log(resp?.data);
            setIsLoading(false);
        }

        console.log(resp?.data);
        if (resp) {
            if (resp.data === 'Evento criado com sucesso' || resp.data == true) {
                const novoArrayVendas = arrayVendas.filter(
                    item =>
                        item.InfoSistema.chaveDocFiscal !== venda.InfoSistema.chaveDocFiscal,
                );
                setArrayVendas(novoArrayVendas);
                /* AsyncStorage.setItem('vendasNaoSalvas', JSON.stringify(novoArrayVendas))
                   .then(() => {
                     console.log('Item adicionado com sucesso ao array vendasNaoSalvas.');
                   })
                   .catch(error => {
                     console.error('Erro ao salvar o array atualizado:', error);
                   });*/
            }
        }

    };

    const renderItem = ({ item }) => {
        const formattedDate = new Date(item.InfoSistema.docDhAut).toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });

        return (
            <Button style={styles.card}
                onClick={() => handleItemPress(item)}
            >
                <span style={styles.cardText}>NF: {item.InfoSistema.numeroDocFiscal}</span>
                <span style={styles.cardText}>
                    Série: {item.InfoSistema.serieDocFiscal}
                </span>
                <span style={styles.cardText}>Data: {formattedDate}</span>

                <span style={styles.cardText}>
                    Cliente:{' '}
                    {item.dest.CPF_dest ? formatarCpfCnpj(item.dest.CPF_dest) : ''}
                </span>


                <span style={styles.cardText}>
                    Valor: {formatarValorEmReais(item.total.ICMStot.vNF)}
                </span>
            </Button>
        );
    };

    const deletarLog = async (chaveNota) => {
        try {
            const options = {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                },
            };
            const response = await axios.delete(
                `${api.techspdv}/v1/logs/chave/${chaveNota}`,
                options
            );
            console.log(response.data);
        } catch (error) {
            console.error('Erro ao acessar o localStorage:', error);
        }
    }

    const criarEvento = async (venda) => {
        let erroBol = false;
        console.log('dentro do criarEvento');

        const options = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + accessToken, // Certifique-se de definir `accessToken`
            },
        };

        try {
            const response = await axios.post(
                `${api.techspdv}/v1/pdveventos/venda`,
                venda,
                options
            );

            if (response.data) {
                console.log('Requisição bem-sucedida');
                await deletarLog(venda.InfoSistema.chaveDocFiscal);
                return response;
            }
        } catch (error) {
            erroBol = true;

            // Tratamento de erro
            if (error.response) {
                console.log('Status de erro:', error.response.status);
                console.log('Dados de erro:', error.response.data);

                const retry = window.confirm(
                    error.response.data || 'Falha ao gravar o histórico. Deseja tentar novamente?'
                );

                if (retry) {
                    console.log('Tentar novamente');
                    return await criarEvento(venda);
                } else {
                    console.log('Usuário escolheu não tentar novamente.');
                    setIsLoading(false);
                    return;
                }
            }

            console.error('Erro inesperado:', error);
            return;
        }
    };

    const cancelarEvento = async (venda, accessToken, setIsLoading) => {
        console.log('dentro do cancelarEvento');
        console.log(venda);

        const options = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + accessToken,
            },
        };

        try {
            await axios.put(
                `${api.techspdv}/v1/pdveventos/cancelar/${venda.InfoSistema.chaveDocFiscal}`,
                venda,
                options
            );
            message.success('Evento cancelado com sucesso.');
        } catch (error) {
            if (error.response) {
                console.error('Status de erro:', error.response.status);
                console.error('Dados de erro:', error.response.data);

                Modal.confirm({
                    title: 'Falha ao cancelar o histórico',
                    content: 'Deseja tentar novamente?',
                    okText: 'Sim',
                    cancelText: 'Não',
                    onOk: () => {
                        cancelarEvento(venda, accessToken, setIsLoading);
                    },
                    onCancel: () => {
                        setIsLoading(false);
                    },
                });
            } else {
                message.error('Erro inesperado ao cancelar o evento.');
                setIsLoading(false);
            }
        }
    };


    const confirmarEventos = async () => {
        setIsLoading(true);

        let novoArrayVendas = arrayVendas;

        for (const venda of products) {
            try {
                let resp = false;
                if (venda.cancelamento && venda.cancelamento === true) {
                    console.log('cancelamento');
                    resp = await cancelarEvento(venda);
                    console.log(resp.data);
                } else {
                    resp = await criarEvento(venda);
                    console.log(resp.data);
                }

                if (resp.data === 'Evento criado com sucesso' || resp.data == true) {
                    novoArrayVendas = novoArrayVendas.filter(
                        item =>
                            item.InfoSistema.chaveDocFiscal !==
                            venda.InfoSistema.chaveDocFiscal,
                    );
                }
            } catch (error) {
                console.error('Erro ao criar evento:', error);
            }
        }
        setArrayVendas(novoArrayVendas);


        console.log('Item adicionado com sucesso ao array vendasNaoSalvas.');
        setIsLoading(false);
    };











    const buscarPorNumeroDaNota = async () => {
        if (accessToken && searchTerm !== null) {
            try {
                const options = {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + accessToken,
                    },
                };
                console.log('busca especifica');
                const response = await axios.get(
                    `${api.techspdv}/v1/pdveventos/chavenumerotipo/${loja.id}/${searchTerm}/0/${config?.tpAmb}`,
                    options,
                );
                console.log(
                    `${api.techspdv}/v1/pdveventos/chavenumerotipo/${loja.id}/${searchTerm}/0/${config?.tpAmb}`,
                );
                if (response.data._embedded?.PDVEvento.length > 0) {
                    setProducts(response.data._embedded.PDVEvento);
                } else {
                    setCurrentPage(0);
                    setProducts([]);
                }
            } catch (error) {
                console.error('Erro ao carregar historico:', error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleDateChange = (dates) => {
        setDates(dates);
        if (dates && dates[0] && dates[1]) {
            setBuscaPorData(true);
            handleSaveDates(dates);
        }
    };


    return (
        <>
            <div style={styles.container}>
                <Modal
                    visible={isModalVisibleLeitor}
                    onCancel={toggleModalLeitor}
                    footer={null}
                >
                    <div style={styles.modalContainer}>

                    </div>
                </Modal>
                <Button
                    type="primary"
                    onClick={closeModal}
                    style={{ backgroundColor: "black", borderColor: "black" }}
                >
                    <span>Voltar</span>
                </Button>

                <div style={styles.buttonContainer}>
                    <Button
                        style={{ ...styles.selectButton, backgroundColor: 'black' }}
                        loading={isLoading}
                        disabled={!loja}
                        onClick={() => {
                            //toggleDateSelectorFalse();
                            setIsLoading(true);
                            setCurrentPage(0);
                            buscaNotas('hoje');
                        }}
                    >
                        <span style={styles.buttonText}>Hoje</span>
                    </Button>

                    <Button
                        style={{ ...styles.selectButton, backgroundColor: 'black' }}
                        loading={isLoading}
                        disabled={!loja}
                        onClick={() => {
                            setIsLoading(true);
                            setCurrentPage(0);
                            buscaNotas('tudo');
                        }}
                    >
                        <span style={styles.buttonText}>Tudo</span>
                    </Button>

                    <RangePicker onChange={handleDateChange} />
                </div>

                <div style={styles.searchContainer}>
                    <Input
                        style={styles.input}
                        placeholder="Pesquisar por numero da nota"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                    <Button
                        style={{ ...styles.searchButton, backgroundColor: 'black' }}
                        loading={isLoading || !loja}
                        disabled={!loja}
                        onClick={async () => {
                            setIsLoading(true);
                            await buscarPorNumeroDaNota();
                        }}
                    >
                        <span style={styles.buttonText}>Pesquisar</span>
                    </Button>
                </div>

                {isLoading ? (
                    <center><Spin size="large" /></center>
                ) : (
                    <List
                        style={{ maxHeight: '650px', overflowY: 'auto' }} // Define uma altura máxima e permite rolagem vertical
                        dataSource={arrayVendas}
                        renderItem={product => renderItem({ item: product })}
                    />
                )}
                <center><Button style={{ backgroundColor: 'black', color: 'white' }} onClick={confirmarEventos}>confirmar</Button></center>
            </div>
        </>
    );
};

const styles = {
    container: {
        padding: '16px',

    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '16px',
    },
    selectButton: {
        flex: 1,
        padding: '20px',
        margin: '5px',
        textAlign: 'center',
        borderRadius: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    selectButton2: {
        flex: 1,
        padding: '20px',
        margin: '5px',
        textAlign: 'center',
        borderRadius: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonText: {
        color: 'white',
        fontSize: '16px',
    },
    searchContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '16px',
    },
    input: {
        flex: 1,
        padding: '10px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#ccc',
        borderRadius: '5px',
    },
    searchButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '21px',
        marginLeft: '10px',
        borderRadius: '5px',

    },
    card: {
        padding: '30px',
        margin: '8px 16px',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#ddd',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    cardText: {
        fontSize: '14px',
        color: '#333',
    },
    modalContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
};
export default Log;
